/* eslint-disable @next/next/no-img-element */

'use client'

import React from 'react'
import { Animations, MultiReveal, Reveal } from '@quark/animation'
import { Text } from '@quark/typography'
import { Container, Flex } from '@quark/layout'
import { NewsCard } from './NewsCard'
import styles from './spotlight.module.scss'

interface SpotlightProps {
  data: any
}

const Spotlight = ({ data }: SpotlightProps) => (
  <div className={styles.newsContainer}>
    <Container type="root">
      <Reveal as="div" animationProps={{ threshold: 0.1, animationDelayMs: 100 }}>
        <Container type="max-parent" paddingBottom={{ lg: 'spacing-80', md: 'spacing-56', sm: 'spacing-32' }}>
          <Text
            as="p"
            fontStyle={{ lg: 'um_text-4xl/bold', md: 'um_text-3xl/bold', sm: 'um_text-3xl/medium' }}
            color="base/primary">
            <span dangerouslySetInnerHTML={{ __html: data?.title || '' }} />
          </Text>
        </Container>
      </Reveal>
      <div className={styles.newsCardContainer}>
        <MultiReveal
          as={Flex}
          animationDelays={(i: number) => 300 + i * 100}
          animationProps={{ animation: Animations.FadeIn50px }}
          flexDirection="column">
          {data?.spotlightCardList?.map((card, i) => (
            <Container type="max-parent" key={i}>
              <NewsCard card={card} key={i} />
            </Container>
          ))}
        </MultiReveal>
      </div>
    </Container>
  </div>
)

export default Spotlight
